import { NotFound } from '@common/components/feedback/NotFound';
import { Layout } from '@common/components/layout/Layout';
import {
  AllocationsPage,
  MultiAllocatedPage,
  PercentageCheckPage,
  PoolPage,
  SummaryPage,
  UnallocatedPage,
} from '@features/allocation';
import { AllocationTagsPage } from '@features/allocation-tag';
import { AzureCallback, LoginPage, ProtectedRoute } from '@features/auth';
import { ProjectListPage } from '@features/project-list';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v7';
import { createBrowserRouter, Outlet } from 'react-router-dom';
import { DocumentTitle, type RouteHandle } from './DocumentTitle';

function RootLayout() {
  return (
    <NuqsAdapter>
      <DocumentTitle />
      <Outlet />
    </NuqsAdapter>
  );
}

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        path: '/login',
        element: <LoginPage />,
        handle: { title: (t) => t('auth:loginTitle') } satisfies RouteHandle,
      },
      { path: '/auth/azure/callback', element: <AzureCallback /> },
      {
        element: <ProtectedRoute />,
        children: [
          {
            element: <Layout />,
            children: [
              {
                index: true,
                element: <AllocationsPage />,
                handle: { title: (t) => t('common:nav.allocations') } satisfies RouteHandle,
              },
              {
                path: 'consultas/pool',
                element: <PoolPage />,
                handle: {
                  title: (t) => t('common:nav.pool'),
                  section: (t) => t('common:nav.checks'),
                  sectionId: 'checks',
                } satisfies RouteHandle,
              },
              {
                path: 'consultas/sem-alocacao',
                element: <UnallocatedPage />,
                handle: {
                  title: (t) => t('common:nav.unallocated'),
                  section: (t) => t('common:nav.checks'),
                  sectionId: 'checks',
                } satisfies RouteHandle,
              },
              {
                path: 'projetos',
                element: <ProjectListPage />,
                handle: { title: (t) => t('common:nav.projects') } satisfies RouteHandle,
              },
              {
                path: 'consultas/multialocados',
                element: <MultiAllocatedPage />,
                handle: {
                  title: (t) => t('common:nav.multiAllocated'),
                  section: (t) => t('common:nav.checks'),
                  sectionId: 'checks',
                } satisfies RouteHandle,
              },
              {
                path: 'consultas/sintese',
                element: <SummaryPage />,
                handle: {
                  title: (t) => t('common:nav.summary'),
                  section: (t) => t('common:nav.checks'),
                  sectionId: 'checks',
                } satisfies RouteHandle,
              },
              {
                path: 'consultas/conferencia-percentual',
                element: <PercentageCheckPage />,
                handle: {
                  title: (t) => t('common:nav.percentageCheck'),
                  section: (t) => t('common:nav.checks'),
                  sectionId: 'checks',
                } satisfies RouteHandle,
              },
              {
                element: <ProtectedRoute allowedRoles={['admin']} />,
                children: [
                  {
                    path: 'tags-alocacao',
                    element: <AllocationTagsPage />,
                    handle: { title: (t) => t('common:nav.allocationTags') } satisfies RouteHandle,
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '*',
        element: <NotFound />,
        handle: { title: (t) => t('common:notFound.title') } satisfies RouteHandle,
      },
    ],
  },
]);
